import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login'
import Home from './views/Home'
import Install from './views/Install'
import Offline from './views/Offline'
// const store = window.require('../store')
// const Store = window.require('electron-store');
// const store = new Store();
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/offline',
      name: 'offline',
      component: Offline
    },
    {
      path: '/install',
      name: 'install',
      component: Install
    }
  ]
})


router.beforeEach((to, from, next) => {

  let isLogin = localStorage.getItem('apiToken') != null ? true : false
  // let appIsInstalled = localStorage.getItem('Delivery-Software-PWA-Prompt')

  if(window.matchMedia('(display-mode: standalone)').matches){
    if(to.name == 'offline'){
      return next();
    }else if(to.name !== 'login' && !isLogin){
      return router.push({ name : 'login'});
    }else if(to.name === 'login' && isLogin){
      return router.push({ name : 'home'});
    }
  }else{
    if(to.name != 'install'){
      return router.push({ name : 'install'})
    }
  }

  return next();
})

export default router
